// src/components/vault/ui/RequirementStatusBadge.tsx
import { Badge } from '../../ui/badge';
import {
  Circle,
  CheckCircle2,
  AlertCircle,
  Lock,
} from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Status } from '../../../redux/interfaces/folder.types';

interface StatusConfig {
  icon: React.ElementType;
  label: string;
  className: string;
}

// Note: Using Status.PendingUpload (not Status.Pending which does not exist)
const statusConfig: Record<Status | 'locked', StatusConfig> = {
  [Status.PendingUpload]: {
    icon: Circle,
    label: 'Pendiente',
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  },
  [Status.PendingReview]: {
    icon: CheckCircle2,
    label: 'Verificado',
    className: 'bg-green-50 text-green-700 border-green-200',
  },
  [Status.Valid]: {
    icon: CheckCircle2,
    label: 'Verificado',
    className: 'bg-green-50 text-green-700 border-green-200',
  },
  [Status.Invalid]: {
    icon: AlertCircle,
    label: 'Rechazado',
    className: 'bg-red-50 text-red-700 border-red-200',
  },
  locked: {
    icon: Lock,
    label: 'Bloqueado',
    className: 'bg-gray-100 text-gray-500 border-gray-200',
  },
};

interface RequirementStatusBadgeProps {
  status: Status;
  locked?: boolean;
}

export function RequirementStatusBadge({
  status,
  locked = false,
}: RequirementStatusBadgeProps) {
  const config = locked ? statusConfig.locked : statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={cn('gap-1 font-normal', config.className)}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}
